var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.maintenance)?_c('TasksList'):_c('Stub',{staticClass:"clnt-stub_sm",attrs:{"title":"Уважаемые партнеры!","text":_vm.textMaintenance,"actions":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }